import vibrateDevice from '@Infra/Haptics/vibrateDevice';

const ARMED_VIBRATION_MS = 10;

/** Gives a short haptic tick when a pull gesture reaches the refresh threshold. */
const signalRefreshArmed = (): void => {
	vibrateDevice(ARMED_VIBRATION_MS);
};

export default signalRefreshArmed;
